import * as Yup from 'yup';

export const initialValuesAccessoryForm = {
    modelNumber: '',
    supplierName: '',
    brand: '',
    supplierId: '',
    location: '',
    brandId: '',
    status: 'active',
    isTaxable: false,
    defaultTaxPercentage: 0.00,
    markupMultiplier: '1.0',
    sku: '',
    supplierUpc: '',
    internalUpc: '',
    supplierCost: '',
    landingCost: '',
    listPrice: '',
    photos: '',
    profit: '',
    profitPercentage: '',
    lastOrdered: '',
    lastReceived: '',
    lastSold: '',
    totalSold: '',
    returned: '',
    quantityOnOrder: '',
    quantityOnHand: '',
    notes: ''
};

const accessoryValidationSchema = Yup.object({
    modelNumber: Yup.string().required('Description is required'),
    brand: Yup.string(),
});

export default accessoryValidationSchema;